// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

// Internal Dependencies:
import NowPlayingButton from 'components/NowPlaying/NowPlayingButton'

class MobileAppMenu extends React.Component {
	render() {
		return (
			<div className="mobile-app-menu">
				<div className="-inner">
					<NavLink to='/listen' exact activeClassName="is-active">
						<i className="icon-note-beamed" aria-hidden="true"></i>

						<span>Listen</span>
					</NavLink>

					<NavLink to='/help' exact activeClassName="is-active">
						<i className="icon-hand-hold" aria-hidden="true"></i>

						<span>Help Us</span>
					</NavLink>

					<NowPlayingButton mobileAppMenu={ true } />

					<NavLink to='/news' exact activeClassName="is-active">
						<i className="icon-news" aria-hidden="true"></i>

						<span>News</span>
					</NavLink>

					<NavLink to='/info' exact activeClassName="is-active">
						<i className="icon-info" aria-hidden="true"></i>

						<span>Info</span>
					</NavLink>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( MobileAppMenu )
